import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { apbApi } from './Base';

export interface PostProposalAnalysisParams {
  batchReport?: boolean;
  headers?: Record<string, string>;
  isInternal: boolean;
  localFilePrefix: string | null;
  pkg: string;
  portfolioId?: string;
  saveLocal: boolean;
}

export interface PostProposalAnalysisPayload {
  proposalAnalysis: object;
  proposalDate: string;
  proposalId: string;
  proposalName: string;
}

export async function postProposalAnalysis(payload: PostProposalAnalysisPayload, params: PostProposalAnalysisParams) {
  const path = 'api/v7/proposal/analysis';
  const response = await apbApi.post<AGraphWrappedType<string, 'proposalId'>>(path, payload, { params });
  return unwrapAGraphResponse(response, 'proposalId');
}

export function getProposalAnalysisByID(responseID: string, pkg: string) {
  const path = `api/v7/proposal/analysis/${responseID}`;
  return apbApi.get(path, { params: { pkg } });
}
